import { render, staticRenderFns } from "./viewQuestionsPage.vue?vue&type=template&id=ae38f944&"
import script from "./viewQuestionsPage.vue?vue&type=script&lang=js&"
export * from "./viewQuestionsPage.vue?vue&type=script&lang=js&"
import style0 from "./viewQuestionsPage.vue?vue&type=style&index=0&id=ae38f944&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports